<template>
  <section class="section section-price">
    <div class="tech-bg">
      <div class="grid-overlay"></div>
      <div class="floating-particles">
        <div class="particle" v-for="n in 30" :key="n" :style="particleStyle()"></div>
      </div>
      <div class="glow-orb glow-orb-1"></div>
      <div class="glow-orb glow-orb-2"></div>
      <div class="glow-orb glow-orb-3"></div>
      <div class="hex-grid"></div>
    </div>
    <div class="container">
      <div class="price-header">
        <div class="header-glow"></div>
        <div class="header-content">
          <div class="tech-badge">
            <span class="badge-dot"></span>
            <span>POWERED BY AI</span>
          </div>
          <h1 class="glitch-text" data-text="选择适合您的订阅方式">选择适合您的订阅方式</h1>
          <p class="subtitle">灵活的订阅方案 · 解锁无限AI创作可能</p>
          <div class="header-line">
            <div class="line-segment"></div>
            <div class="line-segment"></div>
            <div class="line-segment"></div>
          </div>
        </div>
      </div>

      <div class="price-cards">
        <div class="price-card" 
          v-for="(plan, index) in plans" 
          :key="index"
          :class="{ 'featured': plan.featured }"
        >
          <div class="grid-lines"></div>
          <div class="glow-orb glow-orb-1"></div>
          <div class="glow-orb glow-orb-2"></div>
          <div class="corner-decoration corner-tl"></div>
          <div class="corner-decoration corner-tr"></div>
          <div class="corner-decoration corner-bl"></div>
          <div class="corner-decoration corner-br"></div>
          <div class="data-stream"></div>
          <div class="circuit-node"></div>
          <div class="circuit-node"></div>
          <div class="circuit-node"></div>
          <div class="circuit-node"></div>
          <div class="card-badge" v-if="plan.featured">推荐</div>
          <div class="card-header">
            <h3>{{ plan.name }}</h3>
            <p class="description">{{ plan.description }}</p>
          </div>
          <div class="price">
            <span class="currency" v-if="plan.price > 0">¥</span>
            <span class="amount" v-if="plan.price > 0">{{ plan.price }}</span>
            <span class="amount" v-else>免费</span>
            <span class="period" v-if="plan.price > 0">/{{ plan.period }}</span>
          </div>
          <ul class="features">
            <li v-if="plan.monthly_quota === -1">
              <i class="el-icon-check"></i>
              无限次生成
            </li>
            <li v-else-if="plan.monthly_quota > 0">
              <i class="el-icon-check"></i>
              每月 {{ plan.monthly_quota }} 次生成
            </li>
            <li v-else-if="plan.daily_limit > 0">
              <i class="el-icon-check"></i>
              每天 {{ plan.daily_limit }} 次生成
            </li>
            <li>
              <i class="el-icon-check"></i>
              {{ plan.models_access === 'all' ? '全部模型支持' : '基础模型支持' }}
            </li>
            <li>
              <i class="el-icon-check"></i>
              {{ plan.watermark ? '生成结果带水印' : '无水印' }}
            </li>
            <li v-if="plan.price === 0" class="ad-tag ad-supported">
              <i class="el-icon-star-off"></i>
              选择式投放广告
            </li>
            <li v-else class="ad-tag ad-free">
              <i class="el-icon-star-on"></i>
              无广告
            </li>
            <li v-if="plan.api_access">
              <i class="el-icon-check"></i>
              API 接口调用
            </li>
          </ul>
          <div class="card-footer">
            <button class="btn" :class="plan.featured ? 'primary' : 'second'" @click="subscribe(plan)">
              {{ plan.buttonText || plan.button_text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Price',
  data() {
    return {
      plans: []
    }
  },
  mounted() {
    this.loadPlans()
  },
  methods: {
    particleStyle() {
      return {
        left: Math.random() * 100 + '%',
        top: Math.random() * 100 + '%',
        animationDelay: Math.random() * 5 + 's',
        animationDuration: (3 + Math.random() * 4) + 's'
      }
    },
    async loadPlans() {
      try {
        const response = await this.$axios.get('/api/subscription/plans')
        if (response.data.code === 200) {
          this.plans = response.data.data
        }
      } catch (error) {
        console.error('加载订阅方案失败:', error)
      }
    },
    subscribe(plan) {
      if (plan.price === 0) {
        this.$message.info('您可以直接使用免费版本')
      } else if (plan.name === '企业版') {
        this.$message.info('请联系销售获取企业版报价')
      } else {
        this.$router.push({ 
          path: '/subscribe', 
          query: { 
            plan: plan.name, 
            price: plan.price,
            period: plan.period,
            planId: plan.id
          }
        })
      }
    }
  }
}
</script>

<style scoped>
/* 科技背景 */
.section-price {
  padding: 120px 0 60px;
  background: #0d0f16;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.tech-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(0, 230, 172, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 230, 172, 0.02) 1px, transparent 1px);
  background-size: 80px 80px;
  mask-image: radial-gradient(ellipse at center, black 30%, transparent 70%);
}

.floating-particles {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.particle {
  position: absolute;
  width: 3px;
  height: 3px;
  background: #00e6ac;
  border-radius: 50%;
  box-shadow: 0 0 6px #00e6ac, 0 0 12px rgba(0, 230, 172, 0.5);
  animation: float-particle 5s ease-in-out infinite;
  opacity: 0;
}

@keyframes float-particle {
  0%, 100% { opacity: 0; transform: translateY(0) scale(0); }
  25% { opacity: 0.8; transform: translateY(-20px) scale(1); }
  75% { opacity: 0.4; transform: translateY(-40px) scale(0.5); }
}

.container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.price-header {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
}

.header-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 200px;
  background: radial-gradient(ellipse, rgba(0, 230, 172, 0.15), transparent 70%);
  filter: blur(40px);
  pointer-events: none;
  animation: glow-pulse 4s ease-in-out infinite;
}

@keyframes glow-pulse {
  0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(1); }
  50% { opacity: 1; transform: translate(-50%, -50%) scale(1.1); }
}

.header-content {
  position: relative;
}

.tech-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  background: rgba(0, 230, 172, 0.1);
  border: 1px solid rgba(0, 230, 172, 0.3);
  border-radius: 20px;
  font-size: 12px;
  color: #00e6ac;
  letter-spacing: 2px;
  margin-bottom: 20px;
  animation: badge-pulse 2s ease-in-out infinite;
}

@keyframes badge-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(0, 230, 172, 0.3); }
  50% { box-shadow: 0 0 20px 5px rgba(0, 230, 172, 0.1); }
}

.badge-dot {
  width: 6px;
  height: 6px;
  background: #00e6ac;
  border-radius: 50%;
  animation: dot-blink 1.5s ease-in-out infinite;
}

@keyframes dot-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.price-header h1 {
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
  position: relative;
}

.subtitle {
  font-size: 18px;
  color: #8892b0;
  margin-bottom: 30px;
}

.header-line {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.line-segment {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #00e6ac, transparent);
  border-radius: 2px;
  animation: line-flow 2s ease-in-out infinite;
}

.line-segment:nth-child(2) { animation-delay: 0.3s; }
.line-segment:nth-child(3) { animation-delay: 0.6s; }

@keyframes line-flow {
  0%, 100% { opacity: 0.3; width: 40px; }
  50% { opacity: 1; width: 80px; }
}

.price-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 80px;
}

.price-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 32px;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
  backdrop-filter: blur(10px);
}

.price-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 230, 172, 0.05), transparent);
  transition: left 0.5s ease;
}

.price-card:hover::before {
  left: 100%;
}

.price-card:hover {
  transform: translateY(-12px);
  border-color: rgba(0, 230, 172, 0.4);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 40px rgba(0, 230, 172, 0.1),
    inset 0 1px 0 rgba(0, 230, 172, 0.2);
}

.price-card.featured {
  background: linear-gradient(135deg, rgba(0, 230, 172, 0.08), rgba(0, 194, 146, 0.03));
  border: 2px solid rgba(0, 230, 172, 0.5);
  box-shadow: 
    0 0 30px rgba(0, 230, 172, 0.1),
    inset 0 0 30px rgba(0, 230, 172, 0.05);
}

.price-card.featured:hover {
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.5),
    0 0 60px rgba(0, 230, 172, 0.2),
    inset 0 0 40px rgba(0, 230, 172, 0.1);
}

.card-badge {
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #00e6ac, #00c292);
  color: #0a192f;
  padding: 6px 20px;
  border-radius: 0 0 12px 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(0, 230, 172, 0.3);
}

.card-header {
  margin-bottom: 24px;
}

.card-header h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.description {
  font-size: 14px;
  color: #8892b0;
}

.price {
  margin-bottom: 24px;
  display: flex;
  align-items: baseline;
}

.currency {
  font-size: 24px;
  color: #00e6ac;
  font-weight: 600;
}

.amount {
  font-size: 48px;
  font-weight: 700;
  color: #00e6ac;
  margin: 0 4px;
}

.period {
  font-size: 16px;
  color: #8892b0;
}

.features {
  list-style: none;
  margin-bottom: 32px;
}

.features li {
  padding: 12px 0;
  color: #e6f1ff;
  font-size: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  gap: 12px;
}

.features li:last-child {
  border-bottom: none;
}

.features li i {
  color: #00e6ac;
  font-size: 16px;
}

.features li.ad-tag {
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  margin: 4px 0;
}

.features li.ad-supported {
  background: rgba(255, 170, 0, 0.08);
  color: #ffaa00;
  border: 1px solid rgba(255, 170, 0, 0.2);
}

.features li.ad-supported i {
  color: #ffaa00;
}

.features li.ad-free {
  background: rgba(0, 230, 172, 0.08);
  color: #00e6ac;
  border: 1px solid rgba(0, 230, 172, 0.2);
}

.features li.ad-free i {
  color: #00e6ac;
}

.card-footer {
  text-align: center;
}

.btn {
  width: 100%;
  padding: 14px 24px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn.primary {
  background: linear-gradient(135deg, #00e6ac, #00c292);
  color: #0a192f;
  border: none;
}

.btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 230, 172, 0.4);
}

.btn.second {
  background: transparent;
  color: #00e6ac;
  border: 1px solid #00e6ac;
}

.btn.second:hover {
  background: rgba(0, 230, 172, 0.1);
  box-shadow: 0 0 20px rgba(0, 230, 172, 0.15);
}

/* 科技装饰 */
.tech-decoration {
  position: relative;
}

.tech-decoration::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, #00e6ac, transparent, #00e6ac);
  border-radius: 18px;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tech-decoration:hover::before {
  opacity: 0.3;
}

.grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(0, 230, 172, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 230, 172, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  border-radius: 16px;
  overflow: hidden;
}

.hex-grid {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2300e6ac' fill-opacity='0.02'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.4;
}

.glow-orb {
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 230, 172, 0.15), transparent 70%);
  pointer-events: none;
  filter: blur(40px);
  animation: float 6s ease-in-out infinite;
}

.glow-orb-1 {
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.glow-orb-2 {
  bottom: 20%;
  right: 15%;
  animation-delay: 2s;
}

.glow-orb-3 {
  top: 50%;
  left: 50%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(20px, -20px); }
}

.pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  border: 2px solid rgba(0, 230, 172, 0.3);
  border-radius: 50%;
  animation: pulse 3s ease-out infinite;
  pointer-events: none;
}

@keyframes pulse {
  0% {
    width: 100px;
    height: 100px;
    opacity: 1;
  }
  100% {
    width: 300px;
    height: 300px;
    opacity: 0;
  }
}

.corner-decoration {
  position: absolute;
  width: 40px;
  height: 40px;
  pointer-events: none;
}

.corner-tl {
  top: 0;
  left: 0;
  border-top: 2px solid #00e6ac;
  border-left: 2px solid #00e6ac;
  border-radius: 16px 0 0 0;
}

.corner-tr {
  top: 0;
  right: 0;
  border-top: 2px solid #00e6ac;
  border-right: 2px solid #00e6ac;
  border-radius: 0 16px 0 0;
}

.corner-bl {
  bottom: 0;
  left: 0;
  border-bottom: 2px solid #00e6ac;
  border-left: 2px solid #00e6ac;
  border-radius: 0 0 0 16px;
}

.corner-br {
  bottom: 0;
  right: 0;
  border-bottom: 2px solid #00e6ac;
  border-right: 2px solid #00e6ac;
  border-radius: 0 0 16px 0;
}

.price-card.featured .corner-decoration {
  width: 60px;
  height: 60px;
}

.data-stream {
  position: absolute;
  top: 0;
  left: 50%;
  width: 1px;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  opacity: 0.1;
}

.data-stream::after {
  content: '';
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, transparent, #00e6ac, transparent);
  animation: stream 3s linear infinite;
}

@keyframes stream {
  0% { top: -50%; }
  100% { top: 100%; }
}

.circuit-node {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #00e6ac;
  border-radius: 50%;
  box-shadow: 0 0 10px #00e6ac, 0 0 20px rgba(0, 230, 172, 0.5);
  animation: blink 2s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

.circuit-node:nth-child(1) { top: 20%; left: 10%; animation-delay: 0s; }
.circuit-node:nth-child(2) { top: 40%; right: 15%; animation-delay: 0.5s; }
.circuit-node:nth-child(3) { bottom: 30%; left: 20%; animation-delay: 1s; }
.circuit-node:nth-child(4) { top: 60%; right: 25%; animation-delay: 1.5s; }

@media (max-width: 1024px) {
  .price-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .price-cards {
    grid-template-columns: 1fr;
  }
  
  .price-header h1 {
    font-size: 32px;
  }
  
  .amount {
    font-size: 36px;
  }
}
</style>
